module.exports = __webpack_public_path__ + "img/Loyalty-ability-04.0aebf33f.png";